module.exports = __webpack_public_path__ + "img/Asset.49446cb.png";